import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FillScreen } from '@/components/Layout';
import { PackagePatternConfigTable, type ConfigTableRow } from '@/features/operation-package-config-new/PackagePatternConfig';
import useDocumentTitle from '@/hooks/useDocumentTitle';
export const Route = createFileRoute('/_staff/contractor-core/_packages/configs/')({
  component: ConfigsPage
});
function ConfigsPage() {
  useDocumentTitle('Operation Package | Configs');
  const navigate = useNavigate();
  const handlePatternRowClick = (row: ConfigTableRow) => {
    navigate({
      to: '/contractor-core/config/$patternId',
      params: {
        patternId: row.id
      }
    });
  };
  return <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <PackagePatternConfigTable ownerProduct="HRF_CONTRACTOR_CORE" handlePatternRowClick={handlePatternRowClick} />
    </FillScreen>;
}